const SEND_WINDOW_TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
const SEND_WINDOW_BOTH_REQUIRED_MESSAGE =
  "Enter both a send from and a send until time, or leave both empty";

// A time held in the form may carry seconds (HH:mm:ss) as well as the input's HH:mm.
function toHourMinute(value) {
  const text = String(value ?? "");
  return /^\d\d:\d\d:\d\d(\.\d+)?$/.test(text) ? text.slice(0, 5) : text;
}

function isSendWindowTime(value) {
  return SEND_WINDOW_TIME_PATTERN.test(toHourMinute(value));
}

function hasValue(value) {
  return value !== undefined && value !== null && String(value) !== "";
}

// Both times or neither, each HH:mm, with the start before the end (same day).
function validateSendWindowTimes(start, end) {
  if (!hasValue(start) && !hasValue(end)) {
    return "";
  }

  if (!hasValue(start) || !hasValue(end)) {
    return SEND_WINDOW_BOTH_REQUIRED_MESSAGE;
  }

  if (!isSendWindowTime(start) || !isSendWindowTime(end)) {
    return "Enter the times as HH:mm";
  }

  return toHourMinute(start) < toHourMinute(end)
    ? ""
    : "Send until must be after send from";
}

// A field validator for the "from" time: reports only a missing partner.
function validateSendWindowStart(value, values, endName) {
  if (hasValue(value) && !isSendWindowTime(value)) {
    return "Enter the time as HH:mm";
  }

  return hasValue(value) && !hasValue(values?.[endName])
    ? SEND_WINDOW_BOTH_REQUIRED_MESSAGE
    : "";
}

// A field validator for the "until" time: reports a missing partner or a bad order.
function validateSendWindowEnd(value, values, startName) {
  return hasValue(value) || hasValue(values?.[startName])
    ? validateSendWindowTimes(values?.[startName], value)
    : "";
}

export {
  validateSendWindowEnd,
  validateSendWindowStart,
  validateSendWindowTimes,
};
